/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import CarouselInserterConfiguration from 'embercom/objects/series/node/carousel-inserter-configuration';

export default class CarouselNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new CarouselInserterConfiguration();
  category = NODE_CATEGORIES.content;
}
